import BaseGroup, {
  CheckboxGroupProps as BaseGroupProps,
} from 'antd/lib/checkbox/Group'

export interface GroupProps extends BaseGroupProps {}

export const Group = (props: GroupProps): JSX.Element => (
  <>
    <BaseGroup {...props} />
  </>
)
